import { Component} from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SessionService } from '../../../services/session.service';
import { Cliente } from '../../../models/cliente';
import { SweetMessage } from '../../../config/sweet-message';
import { Validation } from '../../../config/validation';
import { ClienteService } from '../../../services/cliente.service';
import { ValidarCorreoService } from '../../../services/validar-correo.service';

@Component({
	selector: 'app-cliente-add',
	templateUrl: './cliente-add.component.html',
	styleUrls: ['./cliente-add.component.css'],
	providers: [
		ClienteService,
		ValidarCorreoService
	]
})
export class ClienteAddComponent{
	public vl: Validation;
	public msgSweet: SweetMessage;
	public cliente: Cliente;
	public loading: boolean;
	public correos: Array<any>;
	public correo: String;
	public correo_invalid:Boolean;

	constructor(
		private storage: AsyncLocalStorage,
		private ss: SessionService,
		public clienteService: ClienteService,
		public correoService: ValidarCorreoService,
	) {
		this.cliente = new Cliente();
		this.cliente.tipo_identificacion_id = 1;
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
		this.loading = false;
		this.correos = [];
		this.correo = "";
		this.correo_invalid = false;
	}


	ngOnInit() {
		// this.validarCorreo();
	}

	isValidForm(){
		if(!this.cliente.razon_social){
			return false
		}
		if(!this.cliente.nombre_comercial){
			return false
		}
		if(!this.cliente.dni){
			return false
		}
		if(!this.cliente.telefono){
			return false
		}
		if(!this.cliente.direccion){
			return false
		}
		if(!this.cliente.tipo_persona){
			return false
		}
		if(!this.cliente.tipo_identificacion_id){
			return false
		}
		if(this.cliente.es_contribuyente){
			if(!this.cliente.num_contribuyente){
				return false;
			}
		}
		if(this.cliente.dni){
			if(this.cliente.tipo_identificacion_id == 1){
				if( this.cliente.dni.length < 13 ){
					return false;
				}else if( isNaN(this.cliente.dni.toString() as any) ){
					return false;
				}
			}
			if(this.cliente.tipo_identificacion_id == 2){
				if( this.cliente.dni.length < 10 ){
					return false;
				}else if( isNaN(this.cliente.dni.toString() as any) ){
					return false;
				}
			}
			if(this.cliente.tipo_identificacion_id == 3 && this.cliente.dni.length < 4){
				return false;
			}
		}

		if(this.cliente.telefono && this.cliente.telefono.length < 4){
			return false;
		}

		if(this.cliente.celular && this.cliente.celular.length < 4){
			return false;
		}
		/*if( !this.correos.length ){
			return false;
		}*/
		if (this.correo_invalid) {
			return false;
		}

		return true;
	}

	onSubmit(){
		this.loading = true;
		this.setValueEntity();
		this.clienteService.save(this.cliente).subscribe(
			res => {
				this.loading = false;
				this.msgSweet.showMessage('success-message', 'Se ha procesado correctamente');
				this.cliente = new Cliente();
				this.cliente.tipo_identificacion_id = 1;
				this.correos = [];
			},
			err => {
				this.loading = false;
				this.msgSweet.showMessage('error-message',err);
			}
		);
	}

	setValueEntity(){
		this.cliente.empresa_id = this.ss.getData("empresa_id");
		this.cliente.usuario_id = this.ss.getData("usuario_id");
		this.cliente.razon_social = this.cliente.razon_social.trim();
		this.cliente.nombre_comercial = this.cliente.nombre_comercial.trim();
		this.cliente.correo = this.correos.toString();
		switch (this.cliente.tipo_identificacion_id){
			case 1: 
				this.cliente.tipo_dni = "RUC";
				break;
			case 2: 
				this.cliente.tipo_dni = "CED";
				break;
			case 3:
				this.cliente.tipo_dni = "PAS";
				break;
		}
	}

	onChangeIdentificacion(id){
		this.cliente.tipo_identificacion_id = id;
	}
	// let res= this.correoService.isEmailValido(this.correos[this.correos.length-1]);
	// blur(event){
	// 	let blur = 0;
	// 	if (event.target.value.trim().length === 0) {
	// 		blur = 1;
	// 	}else{
	// 		blur = 0;
	// 	}		
	// }
	validarCorreo(event){
		if (this.correos.length > 0) {
			let count_true =0;
			let count_false =0;
			if (event.key === "Enter" ) {
				for (let index = 0; index < this.correos.length; index++) {
					let res= this.correoService.isEmailValido(this.correos[index]);
					if (res) {
						count_true ++;
						
					} else {
						count_false ++;
					}
					
				}
				if (count_false > 0) {
					this.correo_invalid = true;
				}else{
					this.correo_invalid = false;
				}
			
			}	
		
		}else{
			this.correo_invalid = false;
		}
	}
	
} 


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/ventas/cliente-add/cliente-add.component.ts